import IQMenuContainer from 'lib/common/contexts/AIContext/components/IQMenuContainer/IQMenuContainer';
import { IQDisplayMode } from 'lib/common/contexts/AIContext/components/constants/IQDisplayMode';

import styles from './iq-shortcut-menu.module.scss';

export default function IQShortcutMenu() {
  return (
    <div data-testid="iq-shortcut-menu" className={styles['askiq-menu__expander-container']}>
      <IQMenuContainer displayMode={IQDisplayMode.COMPACT} />
    </div>
  );
}
